// tabella TURNI

import { defineMessages, useIntl } from 'react-intl';

import PropTypes from 'prop-types';
import React from 'react';
import { RichTextArticle } from '@italia/components/ItaliaTheme/View';

const messages = defineMessages({
  turni: {
    id: 'turni',
    defaultMessage: 'Turni',
  },
  turni_from: {
    id: 'turni_from',
    defaultMessage: 'Dal',
  },
  turni_to: {
    id: 'turni_to',
    defaultMessage: 'Al',
  },
  turni_type: {
    id: 'turni_type',
    defaultMessage: 'Tipo turno',
  },
});

const fmt_dt = (dt) => {
  if (dt && dt.match(/^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2}$/)) {
    return dt.replace(' ', ' ore ');
  }
  return dt;
};

const FarmaciaShifts = ({ content }) => {
  const intl = useIntl();

  return content?.turni?.length > 0 ? (
    <RichTextArticle tag_id="turni" title={intl.formatMessage(messages.turni)}>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th scope="col" className="text-uppercase  no-wrap">
              {intl.formatMessage(messages.turni_from)}
            </th>
            <th scope="col" className="text-uppercase no-wrap">
              {intl.formatMessage(messages.turni_to)}
            </th>
            <th scope="col" className="text-uppercase">
              {intl.formatMessage(messages.turni_type)}
            </th>
          </tr>
        </thead>
        <tbody>
          {content.turni.map((shift) => (
            <tr>
              <td className="no-wrap" style={{ whiteSpace: 'nowrap' }}>
                {fmt_dt(shift.dal)}
              </td>
              <td className="no-wrap" style={{ whiteSpace: 'nowrap' }}>
                {fmt_dt(shift.al)}
              </td>
              <td>{shift?.tipo_turno ? shift.tipo_turno : ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </RichTextArticle>
  ) : (
    <></>
  );
};

FarmaciaShifts.propTypes = {
  content: PropTypes.shape({
    turni: PropTypes.array,
  }).isRequired,
};

export default FarmaciaShifts;
